import React from "react";
import InputField from 'components/fields/InputField';
import { useParams } from 'react-router-dom';
import {apis} from './variables/postmanApis';
import 'react-json-view-lite/dist/index.css';
import { postRequestWithApi } from "stores/ApiHelper";
import ResponseTable from './components/ResponseTable';

const OpsApi = () => {
    let { id } = useParams();
    const api = apis.find(a => a.id === id);
    const getPostData = () => {
        let data = {};
        for(let i = 0; i < api.fields.length; i += 1) data[api.fields[i].id] = '';
        return data;
    }
    const [postData, setPostData] = React.useState(getPostData);
    const [postFiles, setPostFiles] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const [response, setResponse] = React.useState(null);
    const [responseError, setResponseError] = React.useState(null);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const onChange = (e) => {
        if(e.target.type === "file") {
            setPostFiles({ ...postFiles, [e.target.id] : e.target.files[0] });
        }
        setPostData({...postData, [e.target.id] : e.target.value}); 
    }

    const onSubmit = async (e) => {
        try{
            e.preventDefault();
            setLoading(true);
            setResponse(null);
            setResponseError(null);
            const formData = new FormData();
            const headers = {};
            for(let key in postData) {
                if(postFiles[key]) {
                    formData.append(key, postFiles[key]);
                    headers["Content-Type"] = "multipart/form-data";
                }
                else {
                    formData.append(key, postData[key]);
                }
            }
            const res = await postRequestWithApi(api.api, formData, { headers });
            setResponse(res.data);
        }catch(err) {
            console.log("err", err);
            setResponseError(err);
        }
        finally {
            setLoading(false);
        }
    }

    return (
    <div className="px-3 mt-20">
        <h4 className="text-navy-800 block font-sans text-2xl font-semibold leading-snug tracking-normal text-inherit antialiased dark:text-white mb-8">
            {api.name}
        </h4>
        <div className="grid grid-cols-1 md:lg:xl:grid-cols-[auto_1fr] " >
            <form className="mt-8 mb-4 w-80 max-w-screen-lg sm:w-96" onSubmit={onSubmit} >
            {
                api.fields.map(field => {
                    return (
                        <InputField key={field.id} {...field} value={postData[field.id]} onChange={onChange} disabled={loading} />
                    )
                })
            }
            <button
                type="submit"
                className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 disabled:opacity-40"
                disabled={loading}
            >
                Submit
            </button>
             </form>
        </div>
            <ResponseTable data={response} responseError={responseError} />
        </div>
    );
}

export default OpsApi;